var styles = {
  "PlaybackList": "pb-PlaybackList__PlaybackList",
  "PlaybackKey": "pb-PlaybackList__PlaybackKey",
  "PlaybackValue": "pb-PlaybackList__PlaybackValue",
  "PlaybackList--review": "pb-PlaybackList__PlaybackList--review",
  "PlaybackKey--review": "pb-PlaybackList__PlaybackKey--review",
  "PlaybackList--large": "pb-PlaybackList__PlaybackList--large",
  "PlaybackValue--large": "pb-PlaybackList__PlaybackValue--large",
  "PlaybackList--strong": "pb-PlaybackList__PlaybackList--strong",
  "PlaybackValue--strong": "pb-PlaybackList__PlaybackValue--strong"
};
export default styles;